import { MARQUEE_ITEMS } from "@/data/content";

const Marquee = () => {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div className="border-y border-white/10 bg-[#0D1730] py-4 overflow-hidden" data-testid="marquee-strip">
            <div className="animate-marquee flex whitespace-nowrap w-max">
                {items.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-mono2 text-xs tracking-[0.3em] uppercase text-slate-400 px-8">{item}</span>
                        <span className="text-sky-500 text-[10px]">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
